var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemGraph = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M9.5 7a1 1 0 0 1 .776.37l5.8 7.139 4.217-4.216a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.483-.076L9.5 9.586 3.776 16.63a1 1 0 0 1-1.552-1.262l6.5-8A1 1 0 0 1 9.5 7",
  clipRule: "evenodd"
})));
export default SvgGemGraph;